import { render, staticRenderFns } from "./TerminalDisplayAnnouncements.vue?vue&type=template&id=58cbea75"
import script from "./TerminalDisplayAnnouncements.vue?vue&type=script&lang=js"
export * from "./TerminalDisplayAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./TerminalDisplayAnnouncements.vue?vue&type=style&index=0&id=58cbea75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports